
import { Suspense } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import UpcomingEvents from './components/UpcomingEvents';
import RecentSermons from './components/RecentSermons';
import Services from './components/Services';
import Blog from './components/Blog';
import Contact from './components/Contact';
import Footer from './components/Footer';

function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center">Loading...</div>}>
        <Hero />
        <About />
        <UpcomingEvents />
        <RecentSermons />
        <Services />
        <Blog />
        <Contact />
        <Footer />
      </Suspense>
    </div>
  );
}

export default Home;
